export enum MenuItemAction {
  LOGOUT = 'LOGOUT',
  I18N = 'I18N',
  L10N = 'L10N',
}
